import { __awaiter } from "tslib";
/**
 * Base class web plugins should extend.
 */
export class WebPlugin {
    constructor() {
        this.listeners = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) {
            this.addWindowListener(windowListener);
        }
        const remove = () => __awaiter(this, void 0, void 0, function* () { return this.removeListener(eventName, listenerFunc); });
        const p = Promise.resolve({ remove });
        Object.defineProperty(p, 'remove', {
            value: () => __awaiter(this, void 0, void 0, function* () {
                console.warn(`Using addListener() without 'await' is deprecated.`);
                yield remove();
            }),
        });
        return p;
    }
    removeAllListeners() {
        return __awaiter(this, void 0, void 0, function* () {
            this.listeners = {};
            for (const listener in this.windowListeners) {
                this.removeWindowListener(this.windowListeners[listener]);
            }
            this.windowListeners = {};
        });
    }
    notifyListeners(eventName, data) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            listeners.forEach(listener => listener(data));
        }
    }
    hasListeners(eventName) {
        return !!this.listeners[eventName].length;
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: event => {
                this.notifyListeners(pluginEventName, event);
            },
        };
    }
    removeListener(eventName, listenerFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            const listeners = this.listeners[eventName];
            if (!listeners) {
                return;
            }
            const index = listeners.indexOf(listenerFunc);
            this.listeners[eventName].splice(index, 1);
            // If there are no more listeners for this type of event,
            // remove the window listener
            if (!this.listeners[eventName].length) {
                this.removeWindowListener(this.windowListeners[eventName]);
            }
        });
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) {
            return;
        }
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
}
//# sourceMappingURL=web-plugin.js.map